import React, { useState } from "react";
import AgentDetails from "./AgentDetails";
import Header from "./Header";
import ConsentOTP from "./ConsentOTP";

export default function ConsentForm({ isCreditScoreCheck=false }) {
  const [currentScreen, setCurrentScreen] = useState(2);
  const [customer, setCustomer] = useState("");
  const [loading, setLoading] = useState(false);
  const [onecode, setOnecode] = useState(null);
  const [brandSpecific, setBrandSpecific] = useState(false);


  return (
    <div style={{backgroundColor:"white"}}>
      <Header
        currentScreen={4}
        setCurrentScreen={setCurrentScreen}
        isCreditScoreCheck={isCreditScoreCheck}
      />
        <AgentDetails
          currentScreen={currentScreen}
          setOnecode={setOnecode}
          setCustomer={setCustomer}
          setLoading={setLoading}
          loading={loading}
          brandSpecific={brandSpecific}
          setBrandSpecific={setBrandSpecific}
        />
        <ConsentOTP
        customerName={customer?.fullName}
        customerPhoneNum={customer?.phoneNumber}
      />
    </div>
  );
}
